const translation = {
  title: '资源配额',
  create: {
    title: '创建资源配额',
  },
  detail: {
    title: '资源配额详情',
  },
  edit: {
    title: '编辑资源配额',
  },
  form: {
    name: '配额名称',
    nameTooltip: '资源配额的名称',
    description: '描述',
    descriptionTooltip: '资源配额的描述信息',
    cpu: 'CPU 配额',
    cpuTooltip: 'CPU 资源配额',
    memory: '内存配额',
    memoryTooltip: '设置内存资源的最大使用量配额',
    gpu: 'GPU 配额',
    gpuTooltip: 'GPU 资源配额',
    storage: '存储配额',
    storageTooltip: '设置存储资源的最大使用量配额',
    compute: '计算配额',
    computeTooltip: '设置计算资源（CPU/GPU）的最大使用量配额',
    queue: '资源队列',
    queueTooltip: '选择要分配配额的目标资源队列',
    expiredAt: '到期时间',
    expiredAtTooltip: '资源配额到期后将自动失效，不设置则长期有效',
    selectExpiredAt: '选择到期时间',
    confirm: '确定',
    cancel: '取消',
    save: '保存',
    create: '创建',
    delete: '删除',
    domain: '域',
    domainTooltip: '选择资源配额所属的域（顶级组织单元）',
    project: '项目',
    projectTooltip: '选择资源配额所属的项目',
    user: '用户',
    userTooltip: '选择要分配资源配额的目标用户',
    quotaType: '配额类型',
    quotaTypeTooltip: '选择配额类型：存储磁盘或镜像仓库',
    quotaTypeDisk: '存储磁盘',
    quotaTypeHarbor: '镜像仓库',
    storageCluster: '存储集群',
    storageClusterTooltip: '选择配额关联的存储集群',
    registry: '镜像仓库',
    registryTooltip: '选择配额关联的镜像仓库',
    storageSize: '存储大小',
    storageSizeTooltip: '设置允许使用的最大存储容量',
  },
  list: {
    name: '配额名称',
    description: '描述',
    cpu: 'CPU',
    memory: '内存',
    gpu: 'GPU',
    storage: '存储',
    status: '状态',
    createTime: '创建时间',
    updateTime: '更新时间',
    actions: '操作',
    edit: '编辑',
    delete: '删除',
    view: '查看',
    project: '项目',
    user: '用户',
    queue: '资源队列',
    expiredAt: '到期时间',
    search: '搜索',
  },
  status: {
    active: '活跃',
    inactive: '非活跃',
    pending: '待处理',
    error: '错误',
  },
  message: {
    createSuccess: '资源配额创建成功',
    updateSuccess: '资源配额更新成功',
    deleteSuccess: '资源配额删除成功',
    deleteConfirm: '确定要删除这个资源配额吗？',
    deleteWarning: '删除后无法恢复',
  },
}

export default translation
